import type { ComponentType } from 'react';
import type { Locales } from '@/i18n/i18n-types';
import EventsDataLossAug2026EnMdx from './content/events-data-loss-aug-2026.en.mdx';
import EventsDataLossAug2026PtMdx from './content/events-data-loss-aug-2026.pt.mdx';

export type IncidentRegistryEntry = {
  getContent: (locale: Locales) => ComponentType;
};

function localizedIncidentEntry(
  moduleEn: ComponentType,
  modulePt: ComponentType
): IncidentRegistryEntry {
  const modulesByLocale: Record<Locales, ComponentType> = {
    en: moduleEn,
    pt: modulePt,
  };

  return {
    getContent: (locale) => modulesByLocale[locale],
  };
}

export const incidentContentRegistry: Record<string, IncidentRegistryEntry> = {
  'events-data-loss-aug-2026': localizedIncidentEntry(
    EventsDataLossAug2026EnMdx,
    EventsDataLossAug2026PtMdx
  ),
};

export function isIncidentSlug(slug: string): boolean {
  return slug in incidentContentRegistry;
}
